import { create } from 'zustand'
import { SharedSlice, createSharedSlice } from '../../slice'
import createInvoicesSlice, { InvoicesSlice } from './invoices/slice'
import createInvoiceSlice, { InvoiceSlice } from './invoices/edit/slice'
import createStockOnHandSlice, {
  StockOnHandSlice,
} from './reports/stock-on-hand/slice'
import createPredictedOrderSlice, {
  PredictedOrderSlice,
} from './ordering/predicted-order/slice'
import createSharedStockSlice, { StockSharedSlice } from './slice'
import createInvoiceHistorySlice, {
  InvoiceHistorySlice,
} from './invoices/history/slice'
import createReceivedInvoicesSlice, {
  ReceivedInvoicesSlice,
} from './reports/received-invoices/slice'
import createReportsSlice, { ReportsSlice } from './reports/slice'
import createEditSupplierStatementSlice, {
  EditSupplierStatementSlice,
} from './reports/statements/edit/slice'
import createSupplierStatementsSlice, {
  SupplierStatementsSlice,
} from './reports/statements/slice'
import createAddSupplierStatementSlice, {
  AddSupplierStatementSlice,
} from './reports/statements/add/slice'
import createAccountingSystemExportSlice, {
  AccountingSystemExportSlice,
} from './reports/statements/accounting-system-export/slice'
import createExportToSlice, {
  ExportToSlice,
} from './reports/statements/export-to/slice'
import { devtools } from 'zustand/middleware'
import createPurchaseOrderSlice, {
  PurchaseOrderSlice,
} from './ordering/purchase-orders/slice'
import createPurchaseOrderHistorySlice, {
  PurchaseOrderHistorySlice,
} from './ordering/order-history/slice'
import createAddPurchaseOrdersSlice, {
  AddPurchaseOrdersSlice,
} from './ordering/purchase-orders/add/slice'
import createEditPurchaseOrdersSlice, {
  EditPurchaseOrdersSlice,
} from './ordering/purchase-orders/edit/slice'
import createOrderTemplatesSlice, {
  OrderTemplatesSlice,
} from './ordering/order-templates/slice'
import createEditOrderTemplateSlice, {
  EditOrderTemplatesSlice,
} from './ordering/order-templates/edit/slice'

export * from './menus/slice'

const useStockStore = create<
  InvoicesSlice &
    InvoiceSlice &
    StockOnHandSlice &
    PredictedOrderSlice &
    PurchaseOrderSlice &
    PurchaseOrderHistorySlice &
    AddPurchaseOrdersSlice &
    EditPurchaseOrdersSlice &
    SharedSlice &
    StockSharedSlice &
    OrderTemplatesSlice &
    EditOrderTemplatesSlice &
    InvoiceHistorySlice &
    SupplierStatementsSlice &
    ReceivedInvoicesSlice &
    ReportsSlice &
    EditSupplierStatementSlice &
    AddSupplierStatementSlice &
    AccountingSystemExportSlice &
    ExportToSlice
>()(
  devtools(
    (...props) => ({
      ...createSharedSlice(...props),
      ...createSharedStockSlice(...props),
      ...createInvoicesSlice(...props),
      ...createInvoiceSlice(...props),
      ...createStockOnHandSlice(...props),
      ...createPredictedOrderSlice(...props),
      ...createPurchaseOrderSlice(...props),
      ...createPurchaseOrderHistorySlice(...props),
      ...createAddPurchaseOrdersSlice(...props),
      ...createEditPurchaseOrdersSlice(...props),
      ...createOrderTemplatesSlice(...props),
      ...createEditOrderTemplateSlice(...props),
      ...createInvoiceHistorySlice(...props),
      ...createSupplierStatementsSlice(...props),
      ...createReceivedInvoicesSlice(...props),
      ...createReportsSlice(...props),
      ...createEditSupplierStatementSlice(...props),
      ...createAddSupplierStatementSlice(...props),
      ...createAccountingSystemExportSlice(...props),
      ...createExportToSlice(...props),
    }),
    { enabled: process.env.NODE_ENV === 'development', name: 'Stock Store' }
  )
)

export default useStockStore
